import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {useTranslation} from '@/translations/i18n'
import {Helmet} from 'react-helmet'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {DashboardSection} from '@/features/dashboard/components/dashboard-section/DashboardSection'
import {DashboardTherapistRehabilitationCard} from '@/features/dashboard/components/dashboard-therapist-rehabilitation-card/DashboardTherapistRehabilitationCard'
import {DashboardDoctorsPsychologistsCard} from '@/features/dashboard/components/dashboard-doctors-psychologists-card/DashboardDoctorsPsychologistsCard'
import {DashboardConsultantHoursCard} from '@/features/dashboard/components/dashboard-consultant-hours-card/DashboardConsultantHoursCard'
import {DashboardEffectiveCostCard} from '@/features/dashboard/components/dashboard-effective-cost-card/DashboardEffectiveCostCard'
import {DashboardReimbursementConsistencyCard} from '@/features/dashboard/components/dashboard-reimbursement-consistency-card/DashboardReimbursementConsistencyCard'
import {DashboardConsultantFilters} from '@/features/dashboard/components/dashboard-consultant-filters/DashboardConsultantFilters'
import {DashboardLastSyncedAt} from '@/features/dashboard/components/dashboard-last-synced-at/DashboardLastSyncedAt'
import {useGetDashboardConsultants} from '@/features/dashboard/query/useGetDashboardConsultants'

export const DashboardConsultant = () => {
    const {t} = useTranslation()
    const {data} = useGetDashboardConsultants({fields: ['operativeConsultants']})

    return (
        <>
            <Helmet title={`${t('commons:dashboard')} | ${t('dashboard:consultant')}`} />
            <Flexbox direction="column" fullWidth>
                <DashboardSection
                    title={t('dashboard:employed_staff')}
                    endSlot={<DashboardLastSyncedAt lastSyncedAt={data?.lastSyncedAt} />}
                >
                    <Grid columns={2} gap={6} fullWidth>
                        <DashboardTherapistRehabilitationCard />
                        <DashboardDoctorsPsychologistsCard />
                    </Grid>
                </DashboardSection>

                <DashboardSection title={t('dashboard:consultant')} endSlot={<DashboardConsultantFilters />}>
                    <Grid columns={3} gap={6} fullWidth>
                        <DashboardConsultantHoursCard />
                        <DashboardEffectiveCostCard />
                        <DashboardReimbursementConsistencyCard />
                    </Grid>
                </DashboardSection>
            </Flexbox>
        </>
    )
}
